module.exports = __webpack_public_path__ + "media/images/icons/outlined/euro-a97e0ae200b86468b47e89e7031516bb.svg";